import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './filter-button.module.css';
export const FilterButton = ({ active, children, icon, ...props })=>{
    return /*#__PURE__*/ _jsxs("button", {
        ...props,
        "aria-pressed": active,
        className: classNames(styles.tab, active && styles['tab-active']),
        type: "button",
        children: [
            icon,
            children
        ]
    });
};

//# sourceMappingURL=index.js.map